import DocumentCategory from "./enums/DocumentCategory";
import PathInfo from "./PathInfo";

class AnnexDoc {
  constructor(public id: number, public name: string) {}
}

class AnnexData {
  constructor(
    public id_user: number,
    public id_chelement: number | undefined,
    public id_e3dmodel: number | undefined,
    public id_site: number | undefined,
    public title: string,
    public content: string,
    public icon: number | undefined,
    public timestamp: string,
    public category: DocumentCategory,
    public id_annex_docs: Array<number> | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public icon_path?: string | undefined,
    public docs?: Array<AnnexDoc>,
    public docs_name?: string,
    public parent?: PathInfo,
    public username?: string | undefined
  ) {}

  public static EmptyInstance(): AnnexData {
    return new AnnexData(
      -1,
      undefined,
      undefined,
      undefined,
      "",
      "",
      -1,
      "2017-07-21T17:32:28Z",
      DocumentCategory.SITE_INSPECTION,
      undefined
    );
  }
}

export default AnnexData;
